const breakpoints = [
  'mobile',
  'phablet',
  'tablet',
  'desktop',
  'large'
];

const golf = {
  allProducts: 'Shared:ProductNav:AllProducts'
};

export {
  golf,
  breakpoints
};
